
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"104","height":"104","viewBox":"0 0 104 104","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"52","cy":"52","r":"52","fill":"#9C9C9C"}}),_c('path',{attrs:{"d":"M58.25 36.166H39.5a4.139 4.139 0 00-3.833 2.542l-6.291 14.688c-.188.479-.292.979-.292 1.52v4.167a4.179 4.179 0 004.167 4.167h13.146l-1.98 9.52-.062.667c0 .855.354 1.646.917 2.209l2.208 2.187 13.729-13.729a4.14 4.14 0 001.208-2.938V40.334a4.179 4.179 0 00-4.166-4.166zm0 25l-9.041 9.042 2.792-11.125H33.25v-4.166l6.25-14.584h18.75v20.834zm8.334-25h8.333v25h-8.333v-25z","fill":"#fff"}})])
          )
        }
      }
    